import type { ComponentType } from 'react';

import { ChatBubbleIcon, DecisionMakerIcon, GroupsIcon, PetitionIcon, ShareIcon, SpeakerIcon } from '@change/ds-icons';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

export type JourneyStepType = Readonly<{
	Icon: ComponentType<{ size?: number }>;
	number: TranslationKey;
	title: TranslationKey;
	body: TranslationKey;
}>;

export const JOURNEY_STEPS: ReadonlyArray<JourneyStepType & Readonly<{ id: string }>> = [
	{
		id: 'tell_story',
		Icon: ChatBubbleIcon,
		number: translationKey('corgi.vision_page.journey.steps.tell_story.number'),
		title: translationKey('corgi.vision_page.journey.steps.tell_story.title'),
		body: translationKey('corgi.vision_page.journey.steps.tell_story.body'),
	},
	{
		id: 'create_petition',
		Icon: PetitionIcon,
		number: translationKey('corgi.vision_page.journey.steps.create_petition.number'),
		title: translationKey('corgi.vision_page.journey.steps.create_petition.title'),
		body: translationKey('corgi.vision_page.journey.steps.create_petition.body'),
	},
	{
		id: 'share',
		Icon: ShareIcon,
		number: translationKey('corgi.vision_page.journey.steps.share.number'),
		title: translationKey('corgi.vision_page.journey.steps.share.title'),
		body: translationKey('corgi.vision_page.journey.steps.share.body'),
	},
	{
		id: 'rally',
		Icon: GroupsIcon,
		number: translationKey('corgi.vision_page.journey.steps.rally.number'),
		title: translationKey('corgi.vision_page.journey.steps.rally.title'),
		body: translationKey('corgi.vision_page.journey.steps.rally.body'),
	},
	{
		id: 'media',
		Icon: SpeakerIcon,
		number: translationKey('corgi.vision_page.journey.steps.media.number'),
		title: translationKey('corgi.vision_page.journey.steps.media.title'),
		body: translationKey('corgi.vision_page.journey.steps.media.body'),
	},
	{
		id: 'decision_maker',
		Icon: DecisionMakerIcon,
		number: translationKey('corgi.vision_page.journey.steps.decision_maker.number'),
		title: translationKey('corgi.vision_page.journey.steps.decision_maker.title'),
		body: translationKey('corgi.vision_page.journey.steps.decision_maker.body'),
	},
];
